var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.12 122.12"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.06,
    cy: 61.06,
    r: 61.06,
    fill: "#010101"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.1 74.32c0 5.54-2 9.89-6 13.05-4 3.15-9.52 4.73-16.56 4.73s-12.8-1.09-17.28-3.28v-9.63c2.84 1.34 5.85 2.39 9.04 3.15s6.16 1.15 8.92 1.15c4.03 0 7-.77 8.92-2.3 1.92-1.53 2.87-3.6 2.87-6.18 0-2.33-.88-4.31-2.64-5.93-1.76-1.62-5.39-3.54-10.9-5.76-5.68-2.3-9.68-4.93-12-7.89-2.33-2.96-3.49-6.51-3.49-10.66 0-5.2 1.84-9.29 5.53-12.28 3.69-2.98 8.64-4.48 14.86-4.48s11.89 1.31 17.79 3.92l-3.23 8.31c-5.53-2.33-10.47-3.5-14.81-3.5-3.29 0-5.79.72-7.49 2.15-1.7 1.44-2.55 3.33-2.55 5.69 0 1.62.34 3.01 1.02 4.16s1.8 2.24 3.36 3.26c1.56 1.02 4.37 2.37 8.43 4.05 4.57 1.9 7.92 3.68 10.05 5.33s3.69 3.51 4.68 5.58c.99 2.07 1.49 4.52 1.49 7.33z",
    fill: "#fff"
  })));
}
export default SvgS;